let map;
// let marker;
let allStoreList = []; // 所有門市據點
let cityFilterList = []; // 城市篩選
let townFilterList = []; // 鄉鎮篩選
let locationFilterList = []; // 我的所在地篩選
let keywordFilterList = []; // keyword 篩選
let markers = []; // 據點 icon marker
let markerTitles = []; // 門市據點名稱 marker 
let infoOpen = false; // 控制 infoWindows 顯示

let getCenterIsClick = false; // 判定地圖中心點
let atPresentFilter; // 已選擇何種篩選

const getLocation = document.getElementById('getLocation'); // 使用我的所在位置按鈕
let selectCity; // 篩選縣市按鈕
const showClickedSelectCity = document.getElementsByClassName('select-city-list'); // 顯示已點選之選項
let selectTown; // 篩選鄉鎮按鈕
const showClickedSelectTown = document.getElementsByClassName('select-town-list'); // 顯示已點選之選項
const keywordCover = document.getElementsByClassName('store-filter-keyword'); // 關鍵字狀態
const keywordInput = document.getElementsByClassName('keyword-input'); // keyword input
const keywordBtn = document.getElementsByClassName('keyword-btn'); // keyword btn
let functionCheckbox; // 進階篩選 function checkbox
let typeCheckbox; // 進階篩選 type checkbox
let functionCheckboxList;
let typeCheckboxList;
let filterClear = document.getElementsByClassName('filter-clear'); // 重製所有篩選條件
const storeList = document.getElementsByClassName('store-storelist'); // 門市列表區塊，控制是否顯示「查無搜尋結果」
const storeinfo = document.getElementsByClassName('store-eachinfo'); // 取得所有 info
const filterbar = document.getElementsByClassName('store-filterbar'); // 進階篩選欄位，控制顯示樣式
const filterbarindex = document.getElementsByClassName('toggle-filterbar-title-index'); // 顯示已選進階篩選數量
let storenumber = 0;

var listClickMarker;
var listClickInfowindow;

let mask = document.createElement('div');
mask.setAttribute('class', 'lds-mask');
mask.innerHTML = '<div class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>';
document.body.appendChild(mask);
//initMap
function initMap() {

    /**************************************************************/
    /*                           AJAX                             */
    /**************************************************************/

    // Ajax 門市據點列表
    (() => {
        const xhr = new XMLHttpRequest();
        xhr.withCredentials = true;
        // xhr.open('GET', '../../assets/js/mapList.json');
        xhr.open('GET', 'https://' + window.location.host + '/wellcare/tw/store/api/shop');
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.send();
        // <div class="lds-mask"></div>
        xhr.addEventListener('readystatechange', (() => {
            // console.log(xhr.readyState)
            if (xhr.readyState === 4) {
                allStoreList = JSON.parse(xhr.responseText);
                atPresentFilter = '全部門市';
                setMap(allStoreList); // 設置地圖
                markerMaker(allStoreList); // 設置 marker
                printFilterCheckbox(allStoreList); // 印出進階篩選的 checkbox
                printTheStoreList(allStoreList); // 印出商品列表
            }
        }));
    })();

    // Ajax 城市鄉鎮列表
    (() => {
        const xhr = new XMLHttpRequest();
        xhr.withCredentials = true;
        // xhr.open('GET', '../../assets/js/alltaiwanV2.json');
        xhr.open('GET', 'https://' + window.location.host + '/wellcare/tw/store/api/taiwan');
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.send();
        xhr.addEventListener('readystatechange', (() => {
            if (xhr.readyState === 4) {
                printLocationSelectCity(JSON.parse(xhr.responseText));
            }
        }));
    })();

    /**************************************************************/
    /*                印出 filterbar 的 checkbox                  */
    /**************************************************************/
    // .function
    // .type
    // document.createDocumentFragment()

    let printFilterCheckbox = function printFilterCheckbox(filterArry) {
        let filterFunction = document.getElementsByClassName('function-checkbox');
        let functionArray = []; // 篩選完有的類別
        let filterType = document.getElementsByClassName('type-checkbox');
        let typeArray = []; // 篩選完有的類別
        let fragmentFunction = document.createDocumentFragment();
        let fragmenttype = document.createDocumentFragment();

        // 篩出所有類別
        filterArry.forEach((ele, index) => {
            for (let i = 0; i < ele.function.length; i += 1) {
                functionArray.splice(0, 0, ele.function[i]);
            }
            for (let i = 0; i < ele.type.length; i += 1) {
                typeArray.splice(0, 0, ele.type[i]);
            }
        });

        // 刪除重複類別
        functionArray = functionArray.filter((item, num, arr) => arr.indexOf(item) === num);
        typeArray = typeArray.filter((item, num, arr) => arr.indexOf(item) === num);

        // 門市機能性
        for (let i = 0; i < functionArray.length; i += 1) {
            let input = document.createElement('input');
            let label = document.createElement('label');
            input.setAttribute('id', `function${i + 1}`);
            input.setAttribute('type', 'checkbox');
            label.appendChild(document.createElement('span'));
            label.appendChild(document.createTextNode(functionArray[i]));
            label.setAttribute('for', `function${i + 1}`);
            label.setAttribute('class', 'functionCheckbox');
            label.dataset.function = `${functionArray[i]}`;
            fragmentFunction.appendChild(input);
            fragmentFunction.appendChild(label);
        }
        filterFunction[0].appendChild(fragmentFunction);

        // 篩選門市類型
        for (let i = 0; i < typeArray.length; i += 1) {
            let input = document.createElement('input');
            let label = document.createElement('label');
            input.setAttribute('id', `type${i + 1}`);
            input.setAttribute('type', 'checkbox');
            label.appendChild(document.createElement('span'));
            label.appendChild(document.createTextNode(typeArray[i]));
            label.setAttribute('for', `type${i + 1}`);
            label.setAttribute('class', 'typeCheckbox');
            label.dataset.type = `${typeArray[i]}`;
            fragmenttype.appendChild(input);
            fragmenttype.appendChild(label);
        }
        filterType[0].appendChild(fragmenttype);

        functionCheckboxList = document.getElementsByClassName('functionCheckbox');
        typeCheckboxList = document.getElementsByClassName('typeCheckbox');
        setFilters(functionArray, typeArray);
        filterbar[0].className += ' noclickfilter';
    };

    /**************************************************************/
    /*            印出 store-filter-select 的 select              */
    /**************************************************************/

    let printLocationSelectCity = function printLocationSelectCity(cityanTown) {
        let ul = showClickedSelectCity[0].querySelector('ul');
        // 所有縣市選項
        let allCity = document.createDocumentFragment();
        let li = document.createElement('li');
        let span = document.createElement('span');
        span.appendChild(document.createTextNode('所有縣市'));
        li.appendChild(span);
        li.setAttribute('class', 'select-city');
        li.dataset.value = '所有縣市';
        li.dataset.id = '0';
        allCity.appendChild(li);
        ul.appendChild(allCity);
        // 個別縣市選項
        let fragmentCity = document.createDocumentFragment();
        for (let i = 0; i < cityanTown.length; i += 1) {
            let li = document.createElement('li');
            let span = document.createElement('span');
            span.appendChild(document.createTextNode(cityanTown[i].title));
            li.appendChild(span);
            li.setAttribute('class', 'select-city');
            li.dataset.value = `${cityanTown[i].title}`;
            li.dataset.id = `${cityanTown[i].id}`;
            fragmentCity.appendChild(li);
        }
        ul.appendChild(fragmentCity);
        selectCity = document.getElementsByClassName('select-city');
        selectCityClick(cityanTown);
    };

    let printLocationSelectTown = function printLocationSelectTown(cityanTown, id) {
        let ul = showClickedSelectTown[0].querySelector('ul');
        // 個別鄉鎮選項
        let fragmentCity = document.createDocumentFragment();
        cityanTown.forEach((ele) => {
            if (Number(ele.id) === Number(id)) {
                for (let i = 0; i < ele.area.length; i += 1) {
                    let li = document.createElement('li');
                    let span = document.createElement('span');
                    span.appendChild(document.createTextNode(ele.area[i].title));
                    li.appendChild(span);
                    li.setAttribute('class', 'select-town');
                    li.dataset.value = `${ele.area[i].title}`;
                    li.dataset.id = `${ele.area[i].id}`;
                    fragmentCity.appendChild(li);
                }
                while (ul.firstChild) {
                    ul.firstChild.remove();
                }
                ul.appendChild(fragmentCity);
            }
        });
        // 所有鄉鎮選項
        let allTown = document.createDocumentFragment();
        let li = document.createElement('li');
        let span = document.createElement('span');
        span.appendChild(document.createTextNode('所有鄉鎮'));
        li.appendChild(span);
        li.setAttribute('class', 'select-town');
        li.dataset.value = '所有鄉鎮';
        li.dataset.id = '0';
        allTown.appendChild(li);
        ul.prepend(allTown);
        selectTown = document.getElementsByClassName('select-town');
        selectTownClick();
    };

    /**************************************************************/
    /*                       門市據點篩選                          */
    /**************************************************************/

    let customer = {};
    let nofind= Number();

    // 全部清除按鈕
    // 清空篩選
    let resetAllFilterTop = function resetAllFilterTop() {
        // 移除 noclickfilter
        filterbar[0].className += ' noclickfilter';
        if (functionCheckboxList.length > 0) {
            functionCheckboxList.forEach((ele, index) => {
                let checkbox = document.getElementById(`function${index + 1}`);
                checkbox.checked = false;
            });
        }
        if (typeCheckboxList.length > 0) {
            typeCheckboxList.forEach((ele, index) => {
                let checkbox = document.getElementById(`type${index + 1}`);
                checkbox.checked = false;
            });
        }

        // 先全部刪除，避免疊加
        [...childFunction].forEach((ele) => {
            filterbarList[0].removeChild(ele);
        });
        [...childType].forEach((ele) => {
            filterbarList[0].removeChild(ele);
        });
    };

    // 城市 ＆ 鄉鎮篩選
    // selectCity
    let selectCityClick = function selectCityClick(city) {
        for (let i = 0; i < selectCity.length; i += 1) {
            selectCity[i].addEventListener('click', function () {
                resetAllFilterTop();
                resetKeywordFilter();
                nofind = 0;
                let value = selectCity[i].dataset.value;
                let id = selectCity[i].dataset.id;
                // 清空所在位置
                locationFilterList = [];
                getLocation.className = 'store-filter-location';
                (atPresentFilter === '所在位置')?atPresentFilter = '全部門市':atPresentFilter = atPresentFilter;
                // 顯示所選擇縣市名稱
                showClickedSelectCity[0].removeChild(showClickedSelectCity[0].firstChild);
                showClickedSelectCity[0].insertBefore(document.createTextNode(value), showClickedSelectCity[0].firstChild);
                // 重製鄉鎮顯示名稱
                showClickedSelectTown[0].removeChild(showClickedSelectTown[0].firstChild);
                showClickedSelectTown[0].insertBefore(document.createTextNode('選擇鄉鎮'), showClickedSelectTown[0].firstChild);
                let ul = showClickedSelectTown[0].querySelector('ul');
                let fragmentCity = document.createDocumentFragment();
                let li = document.createElement('li');
                let span = document.createElement('span');
                span.appendChild(document.createTextNode('請選擇縣市'));
                li.appendChild(span);
                li.setAttribute('class', 'select-town');
                fragmentCity.appendChild(li);
                while (ul.firstChild) {
                    ul.firstChild.remove();
                }
                ul.appendChild(fragmentCity);

                let fakeArray = [];
                cityFilterList = [];
                townFilterList = [];
                let getLat = 0;
                let getLng = 0;

                if (atPresentFilter === '關鍵字') {
                    if (keywordFilterList.length < 1) {
                        fakeArray = [...allStoreList];
                    }
                    else {
                        fakeArray = [...keywordFilterList];
                    }
                }
                else if (atPresentFilter === '鄉鎮篩選') {
                    fakeArray = [...allStoreList];
                }
                else {
                    fakeArray = [...allStoreList];
                }

                if (Number(id) === 0) {
                    fakeArray.forEach((ele, index) => {
                        cityFilterList.splice(0, 0, ele);
                    });
                    getLat = Number(fakeArray[0].lat);
                    getLng = Number(fakeArray[0].lng);
                }
                else {
                    fakeArray.forEach((ele, index) => {
                        if (Number(ele.city) === Number(id)) {
                            cityFilterList.splice(0, 0, ele);
                            getLat += Number(ele.lat);
                            getLng += Number(ele.lng);
                            // console.log(Number(ele.lat), 'test 2');
                            // console.log(Number(ele.lng), 'test 3');
                            // console.log(ele, 'test 4');
                        } else {
                            nofind += 1;
                        }
                    });
                }

                if (nofind === Number(fakeArray.length)) {
                    getCenterIsClick = false;
                    atPresentFilter = '城市篩選';
                    allStoreList.forEach((ele, index) => {
                        if (Number(ele.city) === Number(id)) {
                            cityFilterList.splice(0, 0, ele);
                            getLat += Number(ele.lat);
                            getLng += Number(ele.lng);
                        }
                    });
                    setMap(cityFilterList); // 設置地圖
                    markerMaker(cityFilterList); // 設置 marker
                    printTheStoreList(cityFilterList, 0); // 印出商品列表
                    printLocationSelectTown(city, id); // 點擊後印出鄉鎮
                }
                else if (Number(id) === 0) {
                    customer.lat = getLat;
                    customer.lng = getLng;
                    getCenterIsClick = true;
                    atPresentFilter = '城市篩選'; // 判斷目前已使用何種篩選
                    setMap(cityFilterList, customer, 13); // 重新設置 map
                    markerMaker(cityFilterList, customer); // 重新設置 marker
                    printTheStoreList(cityFilterList); // 印出商品列表
                    // map.setCenter({ lat: customer.lat, lng: customer.lng }); // 移動至篩選後的範圍
                    printLocationSelectTown(city, id); // 點擊後印出鄉鎮
                }
                else {
                    getLat = getLat / cityFilterList.length;
                    getLng = getLng / cityFilterList.length;
                    customer.lat = getLat;
                    customer.lng = getLng;
                    // console.log('城市篩選', customer, 'test 1');
                    getCenterIsClick = true;
                    atPresentFilter = '城市篩選'; // 判斷目前已使用何種篩選
                    setMap(cityFilterList, customer, 13); // 重新設置 map
                    markerMaker(cityFilterList, customer); // 重新設置 marker
                    printTheStoreList(cityFilterList); // 印出商品列表
                    map.setCenter({ lat: customer.lat, lng: customer.lng }); // 移動至篩選後的範圍
                    printLocationSelectTown(city, id); // 點擊後印出鄉鎮
                }
            });
        }
    };

    // selectTown
    let selectTownClick = function selectTownClick() {
        for (let i = 0; i < selectTown.length; i += 1) {
            selectTown[i].addEventListener('click', function () {
                resetAllFilterTop();
                resetKeywordFilter();
                let fakeArray = [];
                let value = selectTown[i].dataset.value;
                let id = selectTown[i].dataset.id;
                showClickedSelectTown[0].removeChild(showClickedSelectTown[0].firstChild);
                showClickedSelectTown[0].insertBefore(document.createTextNode(value), showClickedSelectTown[0].firstChild);
                townFilterList = []; // 清空之前選擇鄉鎮資料
                let getLat = 0;
                let getLng = 0;
                fakeArray = [...cityFilterList];

                if (Number(id) === 0) {
                    fakeArray.forEach((ele, index) => {
                        townFilterList.splice(0, 0, ele);
                        getLat += Number(ele.lat);
                        getLng += Number(ele.lng);
                    });
                }
                else {
                    fakeArray.forEach((ele, index) => {
                        if (Number(ele.town) === Number(id)) {
                            townFilterList.splice(0, 0, ele);
                            getLat += Number(ele.lat);
                            getLng += Number(ele.lng);
                        }
                    });
                }

                atPresentFilter = '鄉鎮篩選'; // 判斷目前已使用何種篩選
                // 關鍵字交集篩選結果為 0 時
                if (townFilterList.length === 0) {
                    getCenterIsClick = false;
                    // 鄉鎮篩選塞回去 townFilterList
                    cityFilterList.forEach((ele, index) => {
                        if (Number(ele.town) === Number(id)) {
                            townFilterList.splice(0, 0, ele);
                            getLat += Number(ele.lat);
                            getLng += Number(ele.lng);
                        }
                    });
                    setMap(cityFilterList); // 重新設置 map
                    markerMaker(cityFilterList); // 重新設置 marker
                    printTheStoreList(cityFilterList, 0); // 印出商品列表
                }
                else {
                    getCenterIsClick = true;
                    getLat = getLat / townFilterList.length; // 經緯度平均值(重心)
                    getLng = getLng / townFilterList.length; // 經緯度平均值(重心)
                    customer.lat = getLat;
                    customer.lng = getLng;
                    setMap(townFilterList, customer, 14); // 重新設置 map
                    markerMaker(townFilterList, customer); // 重新設置 marker
                    printTheStoreList(townFilterList); // 印出商品列表
                    map.setCenter({ lat: customer.lat, lng: customer.lng }); // 移動至篩選後的範圍
                }
            });
        }
    };

    // 重製下拉選單
    let resetSelectLocation = function resetSelectLocation() {
        cityFilterList = [];
        townFilterList = [];
        // 重製縣市
        showClickedSelectCity[0].removeChild(showClickedSelectCity[0].firstChild);
        showClickedSelectCity[0].insertBefore(document.createTextNode('選擇縣市'), showClickedSelectCity[0].firstChild);
        // 重製鄉鎮
        showClickedSelectTown[0].removeChild(showClickedSelectTown[0].firstChild);
        showClickedSelectTown[0].insertBefore(document.createTextNode('選擇鄉鎮'), showClickedSelectTown[0].firstChild);
        let ul = showClickedSelectTown[0].querySelector('ul');
        let fragmentCity = document.createDocumentFragment();
        let li = document.createElement('li');
        let span = document.createElement('span');
        span.appendChild(document.createTextNode('請選擇縣市'));
        li.appendChild(span);
        li.setAttribute('class', 'select-town');
        fragmentCity.appendChild(li);
        while (ul.firstChild) {
            ul.firstChild.remove();
        }
        ul.appendChild(fragmentCity);
    };
    // keywordCover
    // 使用關鍵字搜尋
    keywordBtn[0].addEventListener('click', function() {
        keywordFilter();
    });
    keywordInput[0].addEventListener('keyup', function(event){
        if (event.keyCode === 13) {
            keywordFilter();
        }
    });
    let keywordFilter = function keywordFilter() {
        resetAllFilterTop();
        let type = '';
        let fakeArray = [];
        let value = keywordInput[0].value;
        let getLat = 0;
        let getLng = 0;
        keywordFilterList = []; // 先清空避免疊加
        // 清空所在位置
        getLocation.className = 'store-filter-location';
        locationFilterList = [];
        (atPresentFilter==='所在位置')?atPresentFilter = '全部門市':atPresentFilter = atPresentFilter;
        // 如果已選擇城市鄉鎮則使用城市鄉鎮做搜尋
        if (townFilterList.length !== 0) {
            fakeArray = [...townFilterList];
            type = '鄉鎮';
        }
        else if (cityFilterList.length !== 0) {
            fakeArray = [...cityFilterList];
            type = '縣市';
        }
        else {
            fakeArray = [...allStoreList];
            type = '全部';
            resetSelectLocation();
        }
        fakeArray.forEach((ele, index) => {
            if (ele.name.indexOf(value) !== -1) {
                keywordFilterList.splice(0, 0, ele);
                getLat += Number(ele.lat);
                getLng += Number(ele.lng);
            }
            else if (ele.address.indexOf(value) !== -1) {
                keywordFilterList.splice(0, 0, ele);
                getLat += Number(ele.lat);
                getLng += Number(ele.lng);
            }
        });
        customer.lat = getLat;
        customer.lng = getLng;
        // 重製搜尋
        if (value.length === 0) {
            switch (type) {
                case '鄉鎮':
                    keywordFilterList = [...townFilterList];
                    atPresentFilter = '鄉鎮篩選';
                    break;
                case '縣市':
                    keywordFilterList = [...cityFilterList];
                    atPresentFilter = '城市篩選';
                    break;
                case '全部':
                    keywordFilterList = [...allStoreList];
                    atPresentFilter = '全部門市';
                    break;
                default:
                    break;
            };
            setMap(keywordFilterList); // 設置地圖
            markerMaker(keywordFilterList); // 設置 marker
            printTheStoreList(keywordFilterList); // 印出商品列表
        }
        // 無搜尋結果
        else if (keywordFilterList.length === 0) {
            switch (type) {
                case '鄉鎮':
                    // keywordFilterList = [...townFilterList];
                    setMap(townFilterList); // 設置地圖
                    markerMaker(townFilterList); // 設置 marker
                    printTheStoreList(townFilterList, 0); // 印出商品列表
                    atPresentFilter = '鄉鎮篩選';
                    break;
                case '縣市':
                    // keywordFilterList = [...cityFilterList];
                    setMap(cityFilterList); // 設置地圖
                    markerMaker(cityFilterList); // 設置 marker
                    printTheStoreList(cityFilterList, 0); // 印出商品列表
                    atPresentFilter = '城市篩選';
                    break;
                case '全部':
                    keywordFilterList = [...allStoreList];
                    setMap(keywordFilterList); // 設置地圖
                    markerMaker(keywordFilterList); // 設置 marker
                    printTheStoreList(keywordFilterList, 0); // 印出商品列表
                    atPresentFilter = '全部門市';
                    break;
                default:
                    break;
            };
        }
        // 顯示搜尋結果
        else {
            keywordCover[0].className = 'store-filter-keyword active'
            atPresentFilter = '關鍵字'; // 判斷目前已使用何種篩選
            setMap(keywordFilterList, customer, 14); // 重新設置 map
            markerMaker(keywordFilterList, customer); // 重新設置 marker
            printTheStoreList(keywordFilterList); // 印出商品列表
        }
    };

    let resetKeywordFilter = function resetKeywordFilter() {
        keywordCover[0].className = 'store-filter-keyword'
        keywordFilterList = [];
        keywordInput[0].value = '';
    };

    // 使用我的所在位置
    getLocation.addEventListener('click', function () {
        resetAllFilterTop();
        resetSelectLocation();
        resetKeywordFilter();
        navigator.geolocation.getCurrentPosition(function (position) {
            customer.lat = position.coords.latitude;
            customer.lng = position.coords.longitude;
            getCenterIsClick = true;
            locationFilterList = []; // 先清空避免疊加
            // map.setCenter({lat: customer.lat, lng: customer.lng});
            allStoreList.forEach((ele, index) => {
                if ((customer.lat - 0.1) < ele.lat && (customer.lat + 0.1) > ele.lat && (customer.lng - 0.1) < ele.lng && (customer.lng + 0.1) > ele.lng) {
                    locationFilterList.splice(0, 0, ele);
                }
            });
            // active
            getLocation.className = 'store-filter-location active';
            atPresentFilter = '所在位置'; // 判斷目前已使用何種篩選
            setMap(locationFilterList, customer, 15); // 重新設置 map
            markerMaker(locationFilterList, customer); // 重新設置 marker
            printTheStoreList(locationFilterList); // 印出商品列表
            // customerMarker(customer); // 顯示自己的定位點
        });
        },
        function() {
            console.log('error');
        },
        {
            enableHighAccuracy: true, // 精準定位
            timeout: 1000, // 超過幾秒做 error
        }
    );

    /**************************************************************/
    /*                     進階門市據點篩選                        */
    /**************************************************************/
    // JSON.parse(JSON.stringify(obj1)) 深拷貝

    // 抓當前點擊的前一次點擊的值
    // console.log(valueArray[(valueArray.indexOf(functionCheckbox[i].dataset.function) + 1)]);
    // console.log(valueArray[(valueArray.indexOf(typeCheckbox.dataset.type) + 1)]);


    let filterbarList = document.getElementsByClassName('store-filterbar-list');
    let childFunction = document.getElementsByClassName('function');
    let childType = document.getElementsByClassName('type');

    function setFilters(fn, ty) {

        functionCheckboxList = [...functionCheckboxList];
        typeCheckboxList = [...typeCheckboxList];

        let valueArray = []; // 點擊順序
        let firstFilter = []; // 第一層
        let secondFilter = []; // 第二層

        functionCheckboxList.forEach((ele, index) => {
            ele.addEventListener('click', function () {
                let checkbox = document.getElementById(`function${index + 1}`);
                switch (atPresentFilter) {
                    case '全部門市':
                        clickFiltersFN(ele, checkbox, allStoreList);
                        break;
                    case '城市篩選':
                        clickFiltersFN(ele, checkbox, cityFilterList);
                        break;
                    case '鄉鎮篩選':
                        clickFiltersFN(ele, checkbox, townFilterList);
                        break;
                    case '所在位置':
                        clickFiltersFN(ele, checkbox, locationFilterList);
                        break;
                    case '關鍵字':
                        clickFiltersFN(ele, checkbox, keywordFilterList);
                        break;
                    default:
                        break;
                };
            });
        });

        typeCheckboxList.forEach((ele, index) => {
            ele.addEventListener('click', function () {
                let checkbox = document.getElementById(`type${index + 1}`);
                switch (atPresentFilter) {
                    case '全部門市':
                        clickFiltersTY(ele, checkbox, allStoreList);
                        break;
                    case '城市篩選':
                        clickFiltersTY(ele, checkbox, cityFilterList);
                        break;
                    case '鄉鎮篩選':
                        clickFiltersTY(ele, checkbox, townFilterList);
                        break;
                    case '所在位置':
                        clickFiltersTY(ele, checkbox, locationFilterList);
                        // customerMarker(customer); // 顯示自己的定位點
                        break;
                    case '關鍵字':
                        clickFiltersTY(ele, checkbox, keywordFilterList);
                        break;
                    default:
                        break;
                };
            });
        });

        /**************************************************************/
        /*                     印出已點選進階篩選                       */
        /**************************************************************/
        let selectedFilter = function selectedFilter(valueArray) {

            // 先全部刪除，避免疊加
            [...childFunction].forEach((ele) => {
                filterbarList[0].removeChild(ele);
            });
            [...childType].forEach((ele) => {
                filterbarList[0].removeChild(ele);
            });

            let fragmentFilterbar = document.createDocumentFragment();
            valueArray.forEach((ele, index) => {
                let span = document.createElement('span');
                if (fn.indexOf(ele) !== -1) {
                    span.setAttribute('class', 'function');
                    span.dataset.function = `${ele}`;
                    span.appendChild(document.createTextNode(ele));
                    span.appendChild(document.createElement('span'));
                    fragmentFilterbar.appendChild(span);
                } else if (ty.indexOf(ele) !== -1) {
                    span.setAttribute('class', 'type');
                    span.dataset.type = `${ele}`;
                    span.appendChild(document.createTextNode(ele));
                    span.appendChild(document.createElement('span'));
                    fragmentFilterbar.appendChild(span);
                }
                filterbarList[0].appendChild(fragmentFilterbar);
            });

            /**************************************************************/
            /*                  點擊已選擇篩選按鈕取消勾選                  */
            /**************************************************************/

            [...childFunction].forEach((ele) => {
                ele.addEventListener('click', function () {

                    functionCheckboxList = [...functionCheckboxList];
                    let data = ele.dataset.function;

                    functionCheckboxList.forEach((item, index) => {
                        if (item.dataset.function === data) {
                            console.log(item);
                            let checkbox = document.getElementById(`function${index + 1}`);
                            switch (atPresentFilter) {
                                case '全部門市':
                                    clickFiltersFN(ele, checkbox, allStoreList);
                                    break;
                                case '城市篩選':
                                    clickFiltersFN(ele, checkbox, cityFilterList);
                                    break;
                                case '鄉鎮篩選':
                                    clickFiltersFN(ele, checkbox, townFilterList);
                                    break;
                                case '所在位置':
                                    clickFiltersFN(ele, checkbox, locationFilterList);
                                    // customerMarker(customer); // 顯示自己的定位點
                                    break;
                                case '關鍵字':
                                    clickFiltersFN(ele, checkbox, keywordFilterList);
                                    break;
                                default:
                                    break;
                            };
                            checkbox.checked = false;
                        }
                    });
                });
            });

            [...childType].forEach((ele) => {
                ele.addEventListener('click', function () {

                    typeCheckboxList = [...typeCheckboxList];
                    let data = ele.dataset.type;

                    typeCheckboxList.forEach((item, index) => {
                        if (item.dataset.type === data) {
                            console.log(item);
                            let checkbox = document.getElementById(`type${index + 1}`);
                            switch (atPresentFilter) {
                                case '全部門市':
                                    clickFiltersTY(ele, checkbox, allStoreList);
                                    break;
                                case '城市篩選':
                                    clickFiltersTY(ele, checkbox, cityFilterList);
                                    break;
                                case '鄉鎮篩選':
                                    clickFiltersTY(ele, checkbox, townFilterList);
                                    break;
                                case '所在位置':
                                    clickFiltersTY(ele, checkbox, locationFilterList);
                                    // customerMarker(customer); // 顯示自己的定位點
                                    break;
                                case '關鍵字':
                                    clickFiltersTY(ele, checkbox, keywordFilterList);
                                    break;
                                default:
                                    break;
                            };
                            checkbox.checked = false;
                        }
                    });
                });
            });
        };

        /**************************************************************/
        /*            刪除所有已勾選的進階篩選選項 重製條件              */
        /**************************************************************/
        let resetAllFilter = function resetAllFilter() {
            filterbarindex[0].textContent = '0';
            
            // 移除 noclickfilter 在 main.js storePage
            
            valueArray = []; // 點擊順序
            firstFilter = []; // 第一層
            secondFilter = []; // 第二層

            functionCheckboxList.forEach((ele, index) => {
                let checkbox = document.getElementById(`function${index + 1}`);
                checkbox.checked = false;
            });
            typeCheckboxList.forEach((ele, index) => {
                let checkbox = document.getElementById(`type${index + 1}`);
                checkbox.checked = false;
            });

            // 先全部刪除，避免疊加
            [...childFunction].forEach((ele) => {
                filterbarList[0].removeChild(ele);
            });
            [...childType].forEach((ele) => {
                filterbarList[0].removeChild(ele);
            });

            switch (atPresentFilter) {
                case '全部門市':
                    setMap(allStoreList); // 重新設置 map
                    markerMaker(allStoreList); // 重新設置 marker
                    printTheStoreList(allStoreList); // 印出商品列表
                    break;
                case '城市篩選':
                    setMap(cityFilterList); // 重新設置 map
                    markerMaker(cityFilterList); // 重新設置 marker
                    printTheStoreList(cityFilterList); // 印出商品列表
                    break;
                case '鄉鎮篩選':
                    setMap(townFilterList); // 重新設置 map
                    markerMaker(townFilterList); // 重新設置 marker
                    printTheStoreList(townFilterList); // 印出商品列表
                    break;
                case '所在位置':
                    setMap(locationFilterList); // 重新設置 map
                    markerMaker(locationFilterList); // 重新設置 marker
                    printTheStoreList(locationFilterList); // 印出商品列表
                    // customerMarker(customer); // 顯示自己的定位點
                    break;
                case '關鍵字':
                    setMap(keywordFilterList); // 重新設置 map
                    markerMaker(keywordFilterList); // 重新設置 marker
                    printTheStoreList(keywordFilterList); // 印出商品列表
                    break;
                default:
                    break;
            };
        };
        filterClear[0].addEventListener('click', resetAllFilter);

        /**************************************************************/
        /*                        篩選函式                             */
        /**************************************************************/
        function clickFiltersFN(functionCheckbox, checkbox, whitchArray) {
            // 選擇前狀態
            if (checkbox.checked === false) {
                // 勾選
                valueArray.splice(0, 0, functionCheckbox.dataset.function);
                if (valueArray.length === 1) {
                    // 第一層 第一次點選全門市篩選
                    whitchArray.filter((item, num) => {
                        for (let j = 0; j < valueArray.length; j += 1) {
                            if (item.function.indexOf(valueArray[j]) !== -1) {
                                firstFilter.splice(0, 0, item);
                            }
                        }
                    });
                    if (firstFilter.length === 0) {
                        printTheStoreList(whitchArray, 0); // 印出商品列表
                        setMap(whitchArray); // 重新設置 map
                        markerMaker(whitchArray); // 重新設置 marker
                    }
                    else {
                        printTheStoreList(firstFilter); // 印出商品列表
                        setMap(firstFilter); // 重新設置 map
                        markerMaker(firstFilter); // 重新設置 marker
                    }
                    filterbar[0].classList.remove('noclickfilter');
                    // customerMarker(customer); // 顯示自己的定位點
                    // console.log('f', firstFilter);
                    // console.log('s', secondFilter);
                } else if (ty.indexOf(valueArray[(valueArray.indexOf(functionCheckbox.dataset.function) + 1)]) !== -1 || ty.indexOf(valueArray[(valueArray.indexOf(functionCheckbox.dataset.function) - 1)]) !== -1) {
                    // 判定前一次點擊是否為同一類
                    // 不同類
                    // 再判斷是否還是位於 secondFilter (2層)
                    // console.log('TYPE', valueArray[(valueArray.indexOf(functionCheckbox.dataset.function) + 1)]);
                    // console.log('TYPE', valueArray[(valueArray.indexOf(functionCheckbox.dataset.function) - 1)]);
                    let fnNum = 0;
                    let tyNum = 0;
                    for (let j = 0; j < valueArray.length; j += 1) {
                        fnNum = fnNum += fn.indexOf(valueArray[j]);
                        tyNum = tyNum += ty.indexOf(valueArray[j]);
                    }
                    if (fnNum === Number(`-${valueArray.length}`)) {
                        // 勾選前為不同層，則為判斷自己
                        console.log('不同類，未使用第二層');
                        firstFilter.filter((item, num) => {
                            for (let j = 0; j < valueArray.length; j += 1) {
                                if (item.function.indexOf(valueArray[j]) !== -1) {
                                    secondFilter.splice(0, 0, item);
                                }
                            }
                        });
                    } else {
                        console.log('不同類，已使用第二層');
                        // 若有第二層按照順序篩選，點擊時若為 FUNCTION 則先篩選 FUNCTION ，再篩選 TYPE，反之則亦然
                        let fakeArrayFn = [];  // 蒐集 valueArray 裡是 FUNCTION 的值
                        let fakeArrayTy = [];  // 蒐集 valueArray 裡是 TYPE 的值
                        fakeArrayFn = valueArray.filter((item, num) => {
                            if (fn.indexOf(item) !== -1) {
                                return item;
                            }
                        });
                        fakeArrayTy = valueArray.filter((item, num) => {
                            if (ty.indexOf(item) !== -1) {
                                return item;
                            }
                        });
                        secondFilter = whitchArray.filter((item, num) => {
                            if (arraysEqual(item.function, fakeArrayFn)) {
                                return item;
                            }
                        });
                        secondFilter = secondFilter.filter((item, num) => {
                            if (arraysEqual(item.type, fakeArrayTy)) {
                                return item;
                            }
                        });
                    }
                    // 刪去重複門市
                    secondFilter = secondFilter.filter((item, num, arr) => arr.indexOf(item) === num);
                    // console.log(secondFilter.length);
                    if (secondFilter.length === 0) {
                        printTheStoreList(arrayMerge(arrayConform(secondFilter, whitchArray, 'type', valueArray), arrayConform(secondFilter, whitchArray, 'function', valueArray)), 0);   // 印出商品列表
                        setMap(arrayMerge(arrayConform(secondFilter, whitchArray, 'type', valueArray), arrayConform(secondFilter, whitchArray, 'function', valueArray))); // 重新設置 map
                        markerMaker(arrayMerge(arrayConform(secondFilter, whitchArray, 'type', valueArray), arrayConform(secondFilter, whitchArray, 'function', valueArray))); // 重新設置 marker
                    } else {
                        printTheStoreList(secondFilter); // 印出商品列表
                        setMap(secondFilter); // 重新設置 map
                        markerMaker(secondFilter); // 重新設置 marker
                    }
                    // console.log('f', firstFilter);
                    // console.log('s', secondFilter);
                } else if (fn.indexOf(valueArray[(valueArray.indexOf(functionCheckbox.dataset.function) + 1)]) !== -1 || fn.indexOf(valueArray[(valueArray.indexOf(functionCheckbox.dataset.function) - 1)]) !== -1) {
                    // 判定前一次點擊是否為同一類
                    // 同類
                    // console.log('FUNCTION', valueArray[(valueArray.indexOf(functionCheckbox.dataset.function) + 1)]);
                    // console.log('FUNCTION', valueArray[(valueArray.indexOf(functionCheckbox.dataset.function) - 1)]);
                    // 再判斷是否還是位於 secondFilter (2層)
                    let fnNum = 0;
                    let tyNum = 0;
                    for (let j = 0; j < valueArray.length; j += 1) {
                        fnNum = fnNum += fn.indexOf(valueArray[j]);
                        tyNum = tyNum += ty.indexOf(valueArray[j]);
                    }
                    if (tyNum === Number(`-${valueArray.length}`)) {
                        console.log('同類，未使用第二層');
                        // 勾選前為同層，則為判斷對方
                        // 若未使用 secondFilter 則使用 firstFilter
                        firstFilter = whitchArray.filter((item, num) => {
                            if (arraysEqual(item.function, valueArray)) {
                                return item;
                            }
                        });
                        // arraysEqual();
                        // 刪去重複門市
                        firstFilter = firstFilter.filter((item, num, arr) => arr.indexOf(item) === num);
                        if (firstFilter.length === 0) {
                            printTheStoreList(arrayConform(firstFilter, whitchArray, 'function', valueArray), 0); // 印出商品列表
                            setMap(arrayConform(firstFilter, whitchArray, 'function', valueArray)); // 重新設置 map
                            markerMaker(arrayConform(firstFilter, whitchArray, 'function', valueArray)); // 重新設置 marker
                        } else {
                            printTheStoreList(firstFilter); // 印出商品列表
                            setMap(firstFilter); // 重新設置 map
                            markerMaker(firstFilter); // 重新設置 marker
                        }
                        // console.log('f', firstFilter);
                        // console.log('s', secondFilter);
                    } else {
                        console.log('同類，已使用第二層');
                        // 第二層使用 secondFilter
                        // 若有第二層按照順序篩選，點擊時若為 FUNCTION 則先篩選 FUNCTION ，再篩選 TYPE，反之則亦然
                        let fakeArrayFn = [];  // 蒐集 valueArray 裡是 FUNCTION 的值
                        let fakeArrayTy = [];  // 蒐集 valueArray 裡是 TYPE 的值
                        fakeArrayFn = valueArray.filter((item, num) => {
                            if (fn.indexOf(item) !== -1) {
                                return item;
                            }
                        });
                        fakeArrayTy = valueArray.filter((item, num) => {
                            if (ty.indexOf(item) !== -1) {
                                return item;
                            }
                        });
                        secondFilter = whitchArray.filter((item, num) => {
                            if (arraysEqual(item.function, fakeArrayFn)) {
                                return item;
                            }
                        });
                        secondFilter = secondFilter.filter((item, num) => {
                            if (arraysEqual(item.type, fakeArrayTy)) {
                                return item;
                            }
                        });
                        // 刪去重複門市
                        secondFilter = secondFilter.filter((item, num, arr) => arr.indexOf(item) === num);
                        if (secondFilter.length === 0) {
                            printTheStoreList(arrayMerge(arrayConform(secondFilter, whitchArray, 'type', valueArray), arrayConform(secondFilter, whitchArray, 'function', valueArray)), 0);   // 印出商品列表
                            setMap(arrayMerge(arrayConform(secondFilter, whitchArray, 'type', valueArray), arrayConform(secondFilter, whitchArray, 'function', valueArray))); // 重新設置 map
                            markerMaker(arrayMerge(arrayConform(secondFilter, whitchArray, 'type', valueArray), arrayConform(secondFilter, whitchArray, 'function', valueArray))); // 重新設置 marker
                            // printTheStoreList(arrayConform(secondFilter, arrayConform(secondFilter, whitchArray, 'function', valueArray), 'type', valueArray), 0);   // 印出商品列表
                            // setMap(arrayConform(secondFilter, arrayConform(secondFilter, whitchArray, 'function', valueArray), 'type', valueArray)); // 重新設置 map
                            // markerMaker(arrayConform(secondFilter, arrayConform(secondFilter, whitchArray, 'function', valueArray), 'type', valueArray)); // 重新設置 marker
                        } else {
                            printTheStoreList(secondFilter); // 印出商品列表
                            setMap(secondFilter); // 重新設置 map
                            markerMaker(secondFilter); // 重新設置 marker
                        }
                        // console.log('f', firstFilter);
                        // console.log('s', secondFilter);
                    }
                }
                // console.log(valueArray);
                selectedFilter(valueArray);
            } else {
                console.log('取消勾選');
                if (valueArray.length === 1) {
                    // 第一層 第一次點選全門市篩選
                    firstFilter = [];
                    secondFilter = [];
                    valueArray.splice(valueArray.indexOf(functionCheckbox.dataset.function), 1);
                    printTheStoreList(whitchArray); // 印出商品列表
                    setMap(whitchArray); // 重新設置 map
                    markerMaker(whitchArray); // 重新設置 marker
                    filterbar[0].className += ' noclickfilter';
                    // console.log('f', firstFilter);
                    // console.log('s', secondFilter);
                } else if (ty.indexOf(valueArray[(valueArray.indexOf(functionCheckbox.dataset.function) + 1)]) !== -1 || ty.indexOf(valueArray[(valueArray.indexOf(functionCheckbox.dataset.function) - 1)]) !== -1) {
                    // 判定前一次點擊是否為同一層 FUNCTION or TYPE
                    // 不同層
                    // console.log('TYPE', valueArray[(valueArray.indexOf(functionCheckbox.dataset.function) + 1)]);
                    // console.log('TYPE', valueArray[(valueArray.indexOf(functionCheckbox.dataset.function) - 1)]);
                    valueArray.splice(valueArray.indexOf(functionCheckbox.dataset.function), 1);
                    // 再判斷是否還是位於 secondFilter (2層)
                    let fnNum = 0;
                    let tyNum = 0;
                    for (let j = 0; j < valueArray.length; j += 1) {
                        fnNum = fnNum += fn.indexOf(valueArray[j]);
                        tyNum = tyNum += ty.indexOf(valueArray[j]);
                    }
                    if (fnNum === Number(`-${valueArray.length}`)) {
                        console.log('不同類，未使用第二層');
                        // 選擇前為不同層，所以判斷自己人是否存在
                        // 自己人不存在，則選完剩對方
                        // 因為剩下為 TYPE，所以使用 TYPE 篩選
                        // 點選完剩同一層，回到最底層開始篩選
                        firstFilter = whitchArray.filter((item, num, arr) => {
                            if (arraysEqual(item.type, valueArray)) {
                                return item;
                            }
                        });
                        // 刪去重複門市
                        firstFilter = firstFilter.filter((item, num, arr) => arr.indexOf(item) === num);
                        if (firstFilter.length === 0) {
                            printTheStoreList(arrayConform(firstFilter, whitchArray, 'type', valueArray),0); // 印出商品列表
                            setMap(arrayConform(firstFilter, whitchArray, 'type', valueArray)); // 重新設置 map
                            markerMaker(arrayConform(firstFilter, whitchArray, 'type', valueArray)); // 重新設置 marker
                        } else {
                            printTheStoreList(firstFilter); // 印出商品列表
                            setMap(firstFilter); // 重新設置 map
                            markerMaker(firstFilter); // 重新設置 marker
                        }
                    } else {
                        console.log('不同類，已使用第二層');
                        // 若有第二層按照順序篩選，點擊時若為 FUNCTION 則先篩選 FUNCTION ，再篩選 TYPE，反之則亦然
                        let fakeArrayFn = [];  // 蒐集 valueArray 裡是 FUNCTION 的值
                        let fakeArrayTy = [];  // 蒐集 valueArray 裡是 TYPE 的值
                        fakeArrayFn = valueArray.filter((item, num) => {
                            if (fn.indexOf(item) !== -1) {
                                return item;
                            }
                        });
                        fakeArrayTy = valueArray.filter((item, num) => {
                            if (ty.indexOf(item) !== -1) {
                                return item;
                            }
                        });
                        secondFilter = whitchArray.filter((item, num) => {
                            if (arraysEqual(item.function, fakeArrayFn)) {
                                return item;
                            }
                        });
                        secondFilter = secondFilter.filter((item, num) => {
                            if (arraysEqual(item.type, fakeArrayTy)) {
                                return item;
                            }
                        });
                        // 刪去重複門市
                        secondFilter = secondFilter.filter((item, num, arr) => arr.indexOf(item) === num);
                        if (secondFilter.length === 0) {
                            printTheStoreList(arrayMerge(arrayConform(secondFilter, whitchArray, 'type', valueArray), arrayConform(secondFilter, whitchArray, 'function', valueArray)), 0);   // 印出商品列表
                            setMap(arrayMerge(arrayConform(secondFilter, whitchArray, 'type', valueArray), arrayConform(secondFilter, whitchArray, 'function', valueArray))); // 重新設置 map
                            markerMaker(arrayMerge(arrayConform(secondFilter, whitchArray, 'type', valueArray), arrayConform(secondFilter, whitchArray, 'function', valueArray))); // 重新設置 marker
                        } else {
                            printTheStoreList(secondFilter); // 印出商品列表
                            setMap(secondFilter); // 重新設置 map
                            markerMaker(secondFilter); // 重新設置 marker
                        }
                    }
                    // console.log('f', firstFilter);
                    // console.log('s', secondFilter);
                } else if (fn.indexOf(valueArray[(valueArray.indexOf(functionCheckbox.dataset.function) + 1)]) !== -1 || fn.indexOf(valueArray[(valueArray.indexOf(functionCheckbox.dataset.function) - 1)]) !== -1) {
                    // 判定前一次點擊是否為同一層 FUNCTION or TYPE
                    // 同層
                    // console.log('FUNCTION', valueArray[(valueArray.indexOf(functionCheckbox.dataset.function) + 1)]);
                    // console.log('FUNCTION', valueArray[(valueArray.indexOf(functionCheckbox.dataset.function) - 1)]);
                    // 再判斷是否還是位於 secondFilter (2層)
                    let fnNum = 0;
                    let tyNum = 0;
                    for (let j = 0; j < valueArray.length; j += 1) {
                        fnNum = fnNum += fn.indexOf(valueArray[j]);
                        tyNum = tyNum += ty.indexOf(valueArray[j]);
                        console.log(fnNum, tyNum);
                    }
                    if (tyNum === Number(`-${valueArray.length}`)) {
                        console.log('同類，未使用第二層');
                        // 選擇前為同層，所以判斷對方是否存在
                        // 對方不存在，則選完剩自己
                        // 若未使用 secondFilter 則使用 firstFilter
                        valueArray.splice(valueArray.indexOf(functionCheckbox.dataset.function), 1);
                        firstFilter = whitchArray.filter((item, num, arr) => {
                            if (arraysEqual(item.function, valueArray)) {
                                return item;
                            }
                        });
                        // 刪去重複門市
                        firstFilter = firstFilter.filter((item, num, arr) => arr.indexOf(item) === num);
                        if (firstFilter.length === 0) {
                            printTheStoreList(arrayConform(firstFilter, whitchArray, 'function', valueArray),0); // 印出商品列表
                            setMap(arrayConform(firstFilter, whitchArray, 'function', valueArray)); // 重新設置 map
                            markerMaker(arrayConform(firstFilter, whitchArray, 'function', valueArray)); // 重新設置 marker
                        } else {
                            printTheStoreList(firstFilter); // 印出商品列表
                            setMap(firstFilter); // 重新設置 map
                            markerMaker(firstFilter); // 重新設置 marker
                        }
                    } else {
                        console.log('同類，已使用第二層');
                        // 第二層使用 secondFilter
                        // 若有第二層按照順序篩選，點擊時若為 FUNCTION 則先篩選 FUNCTION ，再篩選 TYPE，反之則亦然
                        valueArray.splice(valueArray.indexOf(functionCheckbox.dataset.function), 1);
                        let fakeArrayFn = [];  // 蒐集 valueArray 裡是 FUNCTION 的值
                        let fakeArrayTy = [];  // 蒐集 valueArray 裡是 TYPE 的值
                        fakeArrayFn = valueArray.filter((item, num) => {
                            if (fn.indexOf(item) !== -1) {
                                return item;
                            }
                        });
                        fakeArrayTy = valueArray.filter((item, num) => {
                            if (ty.indexOf(item) !== -1) {
                                return item;
                            }
                        });
                        secondFilter = whitchArray.filter((item, num) => {
                            if (arraysEqual(item.function, fakeArrayFn)) {
                                return item;
                            }
                        });
                        secondFilter = secondFilter.filter((item, num) => {
                            if (arraysEqual(item.type, fakeArrayTy)) {
                                return item;
                            }
                        });
                        // 刪去重複門市
                        secondFilter = secondFilter.filter((item, num, arr) => arr.indexOf(item) === num);
                        if (secondFilter.length === 0) {
                            printTheStoreList(arrayMerge(arrayConform(secondFilter, whitchArray, 'type', valueArray), arrayConform(secondFilter, whitchArray, 'function', valueArray)), 0);   // 印出商品列表
                            setMap(arrayMerge(arrayConform(secondFilter, whitchArray, 'type', valueArray), arrayConform(secondFilter, whitchArray, 'function', valueArray))); // 重新設置 map
                            markerMaker(arrayMerge(arrayConform(secondFilter, whitchArray, 'type', valueArray), arrayConform(secondFilter, whitchArray, 'function', valueArray))); // 重新設置 marker
                        } else {
                            printTheStoreList(secondFilter); // 印出商品列表
                            setMap(secondFilter); // 重新設置 map
                            markerMaker(secondFilter); // 重新設置 marker
                        }
                    }
                    // console.log('f', firstFilter);
                    // console.log('s', secondFilter);
                }
                // console.log(valueArray);
                selectedFilter(valueArray);
            }
            filterbarindex[0].textContent = valueArray.length;
        };

        function clickFiltersTY(typeCheckbox, checkbox, whitchArray) {
            // 選擇前狀態
            if (checkbox.checked === false) {
                // 勾選
                valueArray.splice(0, 0, typeCheckbox.dataset.type);
                if (valueArray.length === 1) {
                    // 第一層 第一次點選全門市篩選
                    whitchArray.filter((item, num) => {
                        for (let j = 0; j < valueArray.length; j += 1) {
                            if (item.type.indexOf(valueArray[j]) !== -1) {
                                firstFilter.splice(0, 0, item);
                            }
                        }
                    });
                    if (whitchArray.length === 0) {
                        printTheStoreList(whitchArray, 0); // 印出商品列表
                        setMap(whitchArray); // 重新設置 map
                        markerMaker(whitchArray); // 重新設置 marker
                    }
                    else {
                        printTheStoreList(firstFilter); // 印出商品列表
                        setMap(firstFilter); // 重新設置 map
                        markerMaker(firstFilter); // 重新設置 marker
                    }
                    filterbar[0].classList.remove('noclickfilter');
                    // console.log('f', firstFilter);
                    // console.log('s', secondFilter);
                } else if (ty.indexOf(valueArray[(valueArray.indexOf(typeCheckbox.dataset.type) + 1)]) !== -1 || ty.indexOf(valueArray[(valueArray.indexOf(typeCheckbox.dataset.type) - 1)]) !== -1) {
                    // 判定前一次點擊是否為同一層 FUNCTION or TYPE
                    // 同層
                    // console.log('TYPE', valueArray[(valueArray.indexOf(typeCheckbox.dataset.type) + 1)]);
                    // console.log('TYPE', valueArray[(valueArray.indexOf(typeCheckbox.dataset.type) - 1)]);
                    // 再判斷是否還是位於 secondFilter (2層)
                    let fnNum = 0;
                    let tyNum = 0;
                    for (let j = 0; j < valueArray.length; j += 1) {
                        fnNum = fnNum += fn.indexOf(valueArray[j]);
                        tyNum = tyNum += ty.indexOf(valueArray[j]);
                    }
                    if (fnNum === Number(`-${valueArray.length}`)) {
                        console.log('同類，未使用第二層');
                        // 選擇前為同層，則判斷對方是否存在
                        // 若未使用 secondFilter 則使用 firstFilter
                        firstFilter = whitchArray.filter((item, num) => {
                            if (arraysEqual(item.type, valueArray)) {
                                return item;
                            }
                        });
                        // 刪去重複門市
                        firstFilter = firstFilter.filter((item, num, arr) => arr.indexOf(item) === num);
                        if (firstFilter.length === 0) {
                            // 因為 type 不可能並存，所以兩個以上的 type 一定為 0，所以 printTheStoreList 送 0
                            printTheStoreList(arrayConform(firstFilter, whitchArray, 'type', valueArray), 0); // 印出商品列表
                            setMap(arrayConform(firstFilter, whitchArray, 'type', valueArray)); // 重新設置 map
                            markerMaker(arrayConform(firstFilter, whitchArray, 'type', valueArray)); // 重新設置 marker
                        } else {
                            printTheStoreList(firstFilter); // 印出商品列表
                            setMap(firstFilter); // 重新設置 map
                            markerMaker(firstFilter); // 重新設置 marker
                        }
                    } else {
                        console.log('同類，已使用第二層');
                        // 第二層使用 secondFilter
                        // 若有第二層按照順序篩選，點擊時若為 FUNCTION 則先篩選 FUNCTION ，再篩選 TYPE，反之則亦然
                        let fakeArrayFn = [];  // 蒐集 valueArray 裡是 FUNCTION 的值
                        let fakeArrayTy = [];  // 蒐集 valueArray 裡是 TYPE 的值
                        fakeArrayFn = valueArray.filter((item, num) => {
                            if (fn.indexOf(item) !== -1) {
                                return item;
                            }
                        });
                        fakeArrayTy = valueArray.filter((item, num) => {
                            if (ty.indexOf(item) !== -1) {
                                return item;
                            }
                        });
                        secondFilter = whitchArray.filter((item, num) => {
                            if (arraysEqual(item.type, fakeArrayTy)) {
                                return item;
                            }
                        });
                        secondFilter = secondFilter.filter((item, num) => {
                            if (arraysEqual(item.function, fakeArrayFn)) {
                                return item;
                            }
                        });
                        // 刪去重複門市
                        secondFilter = secondFilter.filter((item, num, arr) => arr.indexOf(item) === num);
                        if (secondFilter.length === 0) {
                            // 因為 type 不可能並存，所以兩個以上的 type 一定為 0，所以 printTheStoreList 送 0
                        printTheStoreList(arrayMerge(arrayConform(secondFilter, whitchArray, 'type', valueArray), arrayConform(secondFilter, whitchArray, 'function', valueArray)), 0);   // 印出商品列表
                        setMap(arrayMerge(arrayConform(secondFilter, whitchArray, 'type', valueArray), arrayConform(secondFilter, whitchArray, 'function', valueArray))); // 重新設置 map
                        markerMaker(arrayMerge(arrayConform(secondFilter, whitchArray, 'type', valueArray), arrayConform(secondFilter, whitchArray, 'function', valueArray))); // 重新設置 marker
                        } else {
                            printTheStoreList(secondFilter); // 印出商品列表
                            setMap(secondFilter); // 重新設置 map
                            markerMaker(secondFilter); // 重新設置 marker
                        }
                    }
                    // console.log('f', firstFilter);
                    // console.log('s', secondFilter);
                } else if (fn.indexOf(valueArray[(valueArray.indexOf(typeCheckbox.dataset.type) + 1)]) !== -1 || fn.indexOf(valueArray[(valueArray.indexOf(typeCheckbox.dataset.type) - 1)]) !== -1) {
                    // 判定前一次點擊是否為同一層 FUNCTION or TYPE
                    // 不同類
                    // 不同類則使用交集，從第一層開始篩選
                    // console.log('FUNCTION', valueArray[(valueArray.indexOf(typeCheckbox.dataset.type) + 1)]);
                    // console.log('FUNCTION', valueArray[(valueArray.indexOf(typeCheckbox.dataset.type) - 1)]);
                    // 再判斷是否還是位於 secondFilter (2層)
                    let fnNum = 0;
                    let tyNum = 0;
                    for (let j = 0; j < valueArray.length; j += 1) {
                        fnNum = fnNum += fn.indexOf(valueArray[j]);
                        tyNum = tyNum += ty.indexOf(valueArray[j]);
                    }
                    if (tyNum === Number(`-${valueArray.length}`)) {
                        console.log('不同類，未使用第二層');
                        // BUG
                        // 選擇前為不同層，所以判斷自己是否存在
                        // 對方不存在，則選完剩自己
                        firstFilter.filter((item, num) => {
                            for (let j = 0; j < valueArray.length; j += 1) {
                                if (item.type.indexOf(valueArray[j]) !== -1) {
                                    secondFilter.splice(0, 0, item);
                                }
                            }
                        });
                    } else {
                        console.log('不同類，已使用第二層');
                        // 若有第二層按照順序篩選，點擊時若為 FUNCTION 則先篩選 FUNCTION ，再篩選 TYPE，反之則亦然
                        let fakeArrayFn = [];  // 蒐集 valueArray 裡是 FUNCTION 的值
                        let fakeArrayTy = [];  // 蒐集 valueArray 裡是 TYPE 的值
                        fakeArrayFn = valueArray.filter((item, num) => {
                            if (fn.indexOf(item) !== -1) {
                                return item;
                            }
                        });
                        fakeArrayTy = valueArray.filter((item, num) => {
                            if (ty.indexOf(item) !== -1) {
                                return item;
                            }
                        });
                        secondFilter = whitchArray.filter((item, num) => {
                            if (arraysEqual(item.type, fakeArrayTy)) {
                                return item;
                            }
                        });
                        secondFilter = secondFilter.filter((item, num) => {
                            if (arraysEqual(item.function, fakeArrayFn)) {
                                return item;
                            }
                        });
                    }
                    // 刪去重複門市
                    secondFilter = secondFilter.filter((item, num, arr) => arr.indexOf(item) === num);
                    // console.log(secondFilter);
                    if (secondFilter.length === 0) {
                        printTheStoreList(arrayMerge(arrayConform(secondFilter, whitchArray, 'type', valueArray), arrayConform(secondFilter, whitchArray, 'function', valueArray)), 0);   // 印出商品列表
                        setMap(arrayMerge(arrayConform(secondFilter, whitchArray, 'type', valueArray), arrayConform(secondFilter, whitchArray, 'function', valueArray))); // 重新設置 map
                        markerMaker(arrayMerge(arrayConform(secondFilter, whitchArray, 'type', valueArray), arrayConform(secondFilter, whitchArray, 'function', valueArray))); // 重新設置 marker
                        // printTheStoreList(arrayConform(secondFilter, arrayConform(secondFilter, whitchArray, 'type', valueArray), 'function', valueArray), 0);   // 印出商品列表
                        // setMap(arrayConform(secondFilter, arrayConform(secondFilter, whitchArray, 'type', valueArray), 'function', valueArray)); // 重新設置 map
                        // markerMaker(arrayConform(secondFilter, arrayConform(secondFilter, whitchArray, 'type', valueArray), 'function', valueArray)); // 重新設置 marker
                    } else {
                        printTheStoreList(secondFilter); // 印出商品列表
                        setMap(secondFilter); // 重新設置 map
                        markerMaker(secondFilter); // 重新設置 marker
                    }
                    secondFilter = secondFilter.filter((item, num, arr) => arr.indexOf(item) === num);
                    // console.log('f', firstFilter);
                    // console.log('s', secondFilter);
                }
                // console.log(valueArray);
                selectedFilter(valueArray);
            } else {
                console.log('取消勾選');
                if (valueArray.length === 1) {
                    // 第一層 第一次點選全門市篩選
                    firstFilter = [];
                    secondFilter = [];
                    valueArray.splice(valueArray.indexOf(typeCheckbox.dataset.type), 1);
                    printTheStoreList(whitchArray); // 印出商品列表
                    setMap(whitchArray); // 重新設置 map
                    markerMaker(whitchArray); // 重新設置 marker
                    filterbar[0].className += ' noclickfilter';
                    // console.log('f', firstFilter);
                    // console.log('s', secondFilter);
                } else if (ty.indexOf(valueArray[(valueArray.indexOf(typeCheckbox.dataset.type) + 1)]) !== -1 || ty.indexOf(valueArray[(valueArray.indexOf(typeCheckbox.dataset.type) - 1)]) !== -1) {
                    // 判定前一次點擊是否為同一層 FUNCTION or TYPE
                    // 同層
                    // console.log('TYPE', valueArray[(valueArray.indexOf(typeCheckbox.dataset.type) + 1)]);
                    // console.log('TYPE', valueArray[(valueArray.indexOf(typeCheckbox.dataset.type) - 1)]);
                    // 再判斷是否還是位於 secondFilter (2層)
                    let fnNum = 0;
                    let tyNum = 0;
                    for (let j = 0; j < valueArray.length; j += 1) {
                        fnNum = fnNum += fn.indexOf(valueArray[j]);
                        tyNum = tyNum += ty.indexOf(valueArray[j]);
                    }
                    if (fnNum === Number(`-${valueArray.length}`)) {
                        console.log('同類，未使用第二層');
                        // 選擇前為同層，所以判斷對方是否存在
                        // 對方不存在，則選完剩自己
                        // 因為 type 為單選 不可能同時存在，所以 firstFilter 為空，須由底層篩選
                        valueArray.splice(valueArray.indexOf(typeCheckbox.dataset.type), 1);
                        firstFilter = whitchArray.filter((item, num, arr) => {
                            if (arraysEqual(item.type, valueArray)) {
                                return item;
                            }
                        });
                        // 刪去重複門市
                        firstFilter = firstFilter.filter((item, num, arr) => arr.indexOf(item) === num);
                        if (firstFilter.length === 0) {
                            // 因為 type 不可能並存，所以兩個以上的 type 一定為 0，所以 printTheStoreList 送 0
                            printTheStoreList(arrayConform(firstFilter, whitchArray, 'type', valueArray), 0); // 印出商品列表
                            setMap(arrayConform(firstFilter, whitchArray, 'type', valueArray)); // 重新設置 map
                            markerMaker(arrayConform(firstFilter, whitchArray, 'type', valueArray)); // 重新設置 marker
                        } else {
                            printTheStoreList(firstFilter); // 印出商品列表
                            setMap(firstFilter); // 重新設置 map
                            markerMaker(firstFilter); // 重新設置 marker
                        }
                        // console.log('f', firstFilter);
                        // console.log('s', secondFilter);
                    } else {
                        console.log('同類，已使用第二層');
                        // 第二層使用 secondFilter
                        // 若有第二層按照順序篩選，點擊時若為 FUNCTION 則先篩選 FUNCTION ，再篩選 TYPE，反之則亦然
                        valueArray.splice(valueArray.indexOf(typeCheckbox.dataset.type), 1);
                        let fakeArrayFn = [];  // 蒐集 valueArray 裡是 FUNCTION 的值
                        let fakeArrayTy = [];  // 蒐集 valueArray 裡是 TYPE 的值
                        fakeArrayFn = valueArray.filter((item, num) => {
                            if (fn.indexOf(item) !== -1) {
                                return item;
                            }
                        });
                        fakeArrayTy = valueArray.filter((item, num) => {
                            if (ty.indexOf(item) !== -1) {
                                return item;
                            }
                        });
                        secondFilter = whitchArray.filter((item, num, arr) => {
                            if (arraysEqual(item.type, fakeArrayTy)) {
                                return item;
                            }
                        });
                        secondFilter = secondFilter.filter((item, num) => {
                            if (arraysEqual(item.function, fakeArrayFn)) {
                                return item;
                            }
                        });
                        // 刪去重複門市
                        secondFilter = secondFilter.filter((item, num, arr) => arr.indexOf(item) === num);
                        if (secondFilter.length === 0) {
                            // 因為 type 不可能並存，所以兩個以上的 type 一定為 0，所以 printTheStoreList 送 0
                        printTheStoreList(arrayMerge(arrayConform(secondFilter, whitchArray, 'type', valueArray), arrayConform(secondFilter, whitchArray, 'function', valueArray)), 0);   // 印出商品列表
                        setMap(arrayMerge(arrayConform(secondFilter, whitchArray, 'type', valueArray), arrayConform(secondFilter, whitchArray, 'function', valueArray))); // 重新設置 map
                        markerMaker(arrayMerge(arrayConform(secondFilter, whitchArray, 'type', valueArray), arrayConform(secondFilter, whitchArray, 'function', valueArray))); // 重新設置 marker
                        } else {
                            printTheStoreList(secondFilter); // 印出商品列表
                            setMap(secondFilter); // 重新設置 map
                            markerMaker(secondFilter); // 重新設置 marker
                        }
                        // console.log('f', firstFilter);
                        // console.log('s', secondFilter);
                    }
                } else if (fn.indexOf(valueArray[(valueArray.indexOf(typeCheckbox.dataset.type) + 1)]) !== -1 || fn.indexOf(valueArray[(valueArray.indexOf(typeCheckbox.dataset.type) - 1)]) !== -1) {
                    // 判定前一次點擊是否為同一層 FUNCTION or TYPE
                    // 不同層
                    // console.log('FUNCTION', valueArray[(valueArray.indexOf(typeCheckbox.dataset.type) + 1)]);
                    // console.log('FUNCTION', valueArray[(valueArray.indexOf(typeCheckbox.dataset.type) - 1)]);
                    valueArray.splice(valueArray.indexOf(typeCheckbox.dataset.type), 1);
                    // 再判斷是否還是位於 secondFilter (2層)
                    let fnNum = 0;
                    let tyNum = 0;
                    for (let j = 0; j < valueArray.length; j += 1) {
                        fnNum = fnNum += fn.indexOf(valueArray[j]);
                        tyNum = tyNum += ty.indexOf(valueArray[j]);
                        console.log(fnNum, tyNum);
                    }
                    if (tyNum === Number(`-${valueArray.length}`)) {
                        console.log('不同類，未使用第二層');
                        // 選擇前為不同層，所以判斷自己人是否存在
                        // 自己人不存在，則選完剩對方
                        // 因為剩下為 FUNCTION，所以使用 FUNCTION 篩選
                        // 點選完剩同一層，回到最底層開始篩選
                        firstFilter = whitchArray.filter((item, num, arr) => {
                            if (arraysEqual(item.function, valueArray)) {
                                return item;
                            }
                        });
                        // 刪去重複門市
                        firstFilter = firstFilter.filter((item, num, arr) => arr.indexOf(item) === num);
                        if (firstFilter.length === 0) {
                            printTheStoreList(arrayConform(firstFilter, whitchArray, 'function', valueArray), 0); // 印出商品列表
                            setMap(arrayConform(firstFilter, whitchArray, 'function', valueArray)); // 重新設置 map
                            markerMaker(arrayConform(firstFilter, whitchArray, 'function', valueArray)); // 重新設置 marker
                        } else {
                            printTheStoreList(firstFilter); // 印出商品列表
                            setMap(firstFilter); // 重新設置 map
                            markerMaker(firstFilter); // 重新設置 marker
                        }
                    } else {
                        console.log('不同類，已使用第二層');
                        // 若有第二層按照順序篩選，點擊時若為 TYPE 則先篩選 TYPE ，再篩選 FUNCTION，反之則亦然
                        let fakeArrayFn = [];  // 蒐集 valueArray 裡是 FUNCTION 的值
                        let fakeArrayTy = [];  // 蒐集 valueArray 裡是 TYPE 的值
                        fakeArrayFn = valueArray.filter((item, num) => {
                            if (fn.indexOf(item) !== -1) {
                                return item;
                            }
                        });
                        fakeArrayTy = valueArray.filter((item, num) => {
                            if (ty.indexOf(item) !== -1) {
                                return item;
                            }
                        });
                        secondFilter = whitchArray.filter((item, num) => {
                            if (arraysEqual(item.type, fakeArrayTy)) {
                                return item;
                            }
                        });
                        secondFilter = secondFilter.filter((item, num) => {
                            if (arraysEqual(item.function, fakeArrayFn)) {
                                return item;
                            }
                        });
                        // 刪除重複門市
                        secondFilter = secondFilter.filter((item, num, arr) => arr.indexOf(item) === num);
                        if (secondFilter.length === 0) {
                            printTheStoreList(arrayMerge(arrayConform(secondFilter, whitchArray, 'type', valueArray), arrayConform(secondFilter, whitchArray, 'function', valueArray)), 0);   // 印出商品列表
                            setMap(arrayMerge(arrayConform(secondFilter, whitchArray, 'type', valueArray), arrayConform(secondFilter, whitchArray, 'function', valueArray))); // 重新設置 map
                            markerMaker(arrayMerge(arrayConform(secondFilter, whitchArray, 'type', valueArray), arrayConform(secondFilter, whitchArray, 'function', valueArray))); // 重新設置 marker
                        } else {
                            printTheStoreList(secondFilter); // 印出商品列表
                            setMap(secondFilter); // 重新設置 map
                            markerMaker(secondFilter); // 重新設置 marker
                        }
                    }
                    // console.log('f', firstFilter);
                    // console.log('s', secondFilter);
                }
                // console.log(valueArray);
                selectedFilter(valueArray);
            }
            filterbarindex[0].textContent = valueArray.length
        };
    };

    /**************************************************************/
    /*                      判斷陣列是否相同                       */
    /**************************************************************/

    function arraysEqual(item, value) {
        let check = 0;
        for(let i = item.length; i--;) {
            for(let j = 0 ; j < value.length; j += 1) {
                if(item[i] === value[j]) {
                    console.log(item[i], 'tag 1');
                    check += 1;
                }
            }
        }
        if(check === value.length) {
            console.log('???')
            return true;
        } else {
            console.log('xxx')
            return false;
        }
    };

    /**************************************************************/
    /*                         陣列處理                            */
    /**************************************************************/

    // 當篩選沒有成立時使用交集
    function arrayConform(someArray, targetArray, x, valueArray) {
        if (x === 'function') {
            someArray = targetArray.filter((item, num) => {
                for (let j = 0; j < valueArray.length; j += 1) {
                    if (item.function.indexOf(valueArray[j]) !== -1) {
                        return item;
                    }
                }
            });
        } else if (x === 'type') {
            someArray = targetArray.filter((item, num) => {
                for (let j = 0; j < valueArray.length; j += 1) {
                    if (item.type.indexOf(valueArray[j]) !== -1) {
                        return item;
                    }
                }
            });
        }
        return someArray;
    };

    function arrayMerge(a,b) {
        let x;
        x = a.concat(b);
        return x;
    };

    /**************************************************************/
    /*                 印出已篩選完畢的門市列表                     */
    /**************************************************************/
    // JSON.parse(JSON.stringify(obj1)) 深拷貝
    let showStoreList = document.getElementsByClassName('show-storelist'); // 篩選完畢後顯示的門市列表
    // let storeinfo = document.getElementsByClassName('store-eachinfo'); // 取得所有 info
    let filternumber = document.getElementsByClassName('filternumber'); // 顯示篩選完畢的數量
    let fragmentStoreList = document.createDocumentFragment();

    function printTheStoreList(filterArray, x) {

        let fakeArray = [];

        // 如果商店數量為0，則建議商店則為當前篩選的陣列為準
        if (x === 0) {
            // 先印出篩選完畢的商店數量
            filternumber[0].textContent = '0';
            storeList[0].className += ' nostoreshow';
            fakeArray = JSON.parse(JSON.stringify(filterArray));
        } else {
            // 先印出篩選完畢的商店數量
            filternumber[0].textContent = `${filterArray.length}`;
            storeList[0].classList.remove('nostoreshow');
            fakeArray = JSON.parse(JSON.stringify(filterArray));
        }

        // 先全部刪除，避免疊加
        [...storeinfo].forEach((ele) => {
            showStoreList[0].removeChild(ele);
        });

        fakeArray.forEach((ele, index) => {

            let li = document.createElement('li');
            // router
            let a = document.createElement('a');
            let storeTitle = document.createElement('p');
            let postalcode = document.createElement('span');
            let address = document.createElement('p');
            let telTitle = document.createElement('span');
            let tel = document.createElement('p');
            let faxTitle = document.createElement('span');
            let fax = document.createElement('p');
            let contact = document.createElement('div');
            let fnTitle = document.createElement('span');
            let infoFn = document.createElement('p');
            let tyTitle = document.createElement('span');
            let infoTy = document.createElement('p');
            let info = document.createElement('div');

            li.dataset.index = `${index + 1}`;
            li.setAttribute('class', 'store-eachinfo');
            li.setAttribute('data-lat', ele.lat);
            li.setAttribute('data-lng', ele.lng);
            li.setAttribute('data-name', ele.name);
            // https://${window.location.host}/wellcare/tw/store/${ele.id}
            // a.setAttribute('href', 'javascript:void(0)');
            a.setAttribute('href', 'https://' + window.location.host + '/wellcare/tw/store/' + ele.id);
            a.setAttribute('target', '_blank');
            a.dataset.href = `store_detail/${ele.id}`;
            storeTitle.appendChild(document.createTextNode(`${ele.city_en} ${ele.name}`));
            postalcode.appendChild(document.createTextNode(ele.postalcode));
            address.appendChild(postalcode);
            address.appendChild(document.createTextNode(ele.address));
            telTitle.appendChild(document.createTextNode('TEL：'));
            tel.appendChild(telTitle);
            tel.appendChild(document.createTextNode(ele.tel));
            faxTitle.appendChild(document.createTextNode('FAX：'));
            fax.appendChild(faxTitle);
            fax.appendChild(document.createTextNode(ele.fax));
            contact.appendChild(tel);
            contact.appendChild(fax);

            fnTitle.appendChild(document.createTextNode('機能性：'));
            infoFn.appendChild(fnTitle);
            for (let i = 0; i < ele.function.length; i +=1) {
                if (i === (ele.function.length - 1)) {
                    infoFn.appendChild(document.createTextNode(ele.function[i]));
                } else {
                    infoFn.appendChild(document.createTextNode(`${ele.function[i]}、`));
                }
            }
            tyTitle.appendChild(document.createTextNode('門市類型：'));
            infoTy.appendChild(tyTitle);
            for (let i = 0; i < ele.type.length; i +=1) {
                if (i === (ele.type.length - 1)) {
                    infoTy.appendChild(document.createTextNode(ele.type[i]));
                } else {
                    infoTy.appendChild(document.createTextNode(`${ele.type[i]}、`));
                }
            }
            info.appendChild(infoFn);
            info.appendChild(infoTy);
            
            a.appendChild(storeTitle);
            a.appendChild(address);
            a.appendChild(contact);
            a.appendChild(info);
            li.appendChild(a);

            fragmentStoreList.appendChild(li);
            showStoreList[0].appendChild(fragmentStoreList);

            // 解決 scrollbar
            $('.store-storelist-list').attr('style', '').css({'overflow': 'hidden'});
        });
        listMoveMap(filterArray);
    };

    /**************************************************************/
    /*                         地圖相關                            */
    /**************************************************************/

    // 初始 & 篩選中心點
    let mapCenterPoint = function mapCenterPoint(array) {
        let center = {};
        center.lat = array[0].lat;
        center.lng = array[0].lng;
        return { lat: Number(center.lat), lng: Number(center.lng) };
    };

    // 初始化地圖經緯度
    let setMapPosition = function setMapPosition(array, obj) {
        // console.log(obj);
        if (getCenterIsClick) {
            // console.log('yes', getCenterIsClick);
            getCenterIsClick = false;
            return { lat: Number(obj.lat), lng: Number(obj.lng) };
        } else {
            // console.log('No', getCenterIsClick);
            return mapCenterPoint(array);
        }
    };

    // 初始化地圖縮放程度
    let setZoom = function setZoom(num) {
        if (num === undefined || num === null) {
            return 14;
        } else {
            return num;
        }
    };

    // 初始化地圖
    function setMap(array, latlng, zoom) {
        map = new google.maps.Map(document.getElementById('map'), {
            center: setMapPosition(array, latlng),
            zoom: setZoom(zoom), // 初始可視範圍
            mapTypeControl: false,
            streetViewControl: false,
            styles: [
                {
                    "featureType": "administrative.land_parcel",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "labels.text",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "poi.business",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
            ],
        });

        // 縮放時隱藏名稱 Marker
        google.maps.event.addListener(map, 'zoom_changed', function () {
            let zoom = map.getZoom();
            let fakeArray = [];
            switch (atPresentFilter) {
                case '全部門市':
                    fakeArray = [...allStoreList];
                    break;
                case '城市篩選':
                    fakeArray = [...cityFilterList];
                    break;
                case '鄉鎮篩選':
                    fakeArray = [...townFilterList];
                    break;
                case '所在位置':
                    fakeArray = [...locationFilterList];
                    break;
                case '關鍵字':
                    fakeArray = [...keywordFilterList];
                    break;
                default:
                    break;
            };
            for (let j = 0; j < fakeArray.length; j += 1) {
                // zoom 大於多少時顯示
                markerTitles[j].setVisible(zoom >= 13);
            }
        });
    };

    // 強制讓 infowindow 只能開啟一個
    let clearAllInfoWindows = function clearAllInfoWindows(map) {
        markers.forEach((ele) => {
            ele.infowindow.close(map, ele);
            ele.setIcon({url: '../../upload/F2E/store/googlemapmark.png', labelOrigin: new google.maps.Point(15, 15)});
        });
        if (listClickMarker) {
            listClickMarker.setMap(null);
        }
    };

    // 設置地標
    function markerMaker(filterStoreLsit, latlng) {
        if (filterStoreLsit === undefined || filterStoreLsit === null || filterStoreLsit.length === 0) {
            // console.log('附近沒有店家');
            // console.log(latlng);
            // 印出推薦店家
            // ...
            return
        }

        filterStoreLsit.forEach((ele, index) => {
            // 點擊 Marker 出現的 info 視窗
            // 網址：網域 + wellcare/tw/store/ + 門市id
            let infowindow = new google.maps.InfoWindow({
                content: `
                <div class="storeinfo">
                    <a herf="javascript:void(0)">
                        <div><img src="${ele.image}"></div>
                        <div>
                            <p>${ele.city_en} ${ele.name}</p>
                            <p><span>${ele.postalcode} </span>${ele.address}</p>
                            <p>
                                <span>TEL：</span>${ele.tel}
                            </p>
                            <p>
                                <span>FAX：</span>${ele.fax}
                            </p>
                            <div class="storedetail" data-src="https://${window.location.host}/wellcare/tw/store/${ele.id}" target="_blank">DETAIL 了解內容</div>
                        </div>
                    </a>
                </div>`,
                position: { lat: Number(ele.lat), lng: Number(ele.lng) },
            });
            
            // icon Marker
            let marker = new google.maps.Marker({
                position: { lat: Number(ele.lat), lng: Number(ele.lng) },
                map: map,
                icon: {
                    url: '../../upload/F2E/store/googlemapmark.png',
                    labelOrigin: new google.maps.Point(15, 15)
                },
                infowindow: infowindow
            });
            markers.push(marker);
            // label: {
            //     text: `${index + 1}`,
            //     fontSize: '14px',
            //     fontWeight: '700',
            // },

            let markerTitle = new google.maps.Marker({
                position: { lat: Number(ele.lat), lng: Number(ele.lng) },
                map: map,
                icon: {
                    url: '../../upload/F2E/store/mapmarktitle.png',
                    labelOrigin: new google.maps.Point(1, 15),
                },
                label: {
                    text: `${ele.name}`,
                    fontFamily: 'Microsoft JhengHei',
                    fontWeight: '700'
                },
            });
            markerTitles.push(markerTitle);

            // 控制點擊 Marker 時開關 infowindow
            marker.addListener('click', function () {
                let vm = this;

                // 重複點擊關閉 infowindow
                if(vm.infowindow.getMap() !== undefined && vm.infowindow.getMap() !== null){
                    vm.infowindow.close(map, vm);
                    vm.setIcon({url: '../../upload/F2E/store/googlemapmark.png', labelOrigin: new google.maps.Point(15, 15)});
                    // map.setZoom(14);
                    return; 
                }

                // 關閉所有 infowindow
                clearAllInfoWindows(map);
                // 打開 該點擊的 infowindow
                marker.infowindow.open(map, vm);
                // console.log(marker,'marker');
                // console.log(map,'map');
                // map.setZoom(18);
                vm.setIcon({url: '../../upload/F2E/store/googlemapmark-focus.png', labelOrigin: new google.maps.Point(15, 15)});
            });
        });
    };

    // 使用我的所在位置時的 marker
    // function customerMarker(obj) {
    //     let marker = new google.maps.Marker({
    //         position: obj,
    //         map: map,
    //         animation: google.maps.Animation.DROP,
    //     });
    // };

    // 列表帶動地圖
    function listMoveMap(array) {
        if (window.innerWidth > 1025 && !mobile()) {
            [...storeinfo].forEach((ele) => {
                ele.addEventListener('click', function(e) {
                    e.preventDefault();
                    if (listClickMarker) {
                        listClickInfowindow.close();
                        listClickMarker.setIcon({url: '../../upload/F2E/store/googlemapmark.png', labelOrigin: new google.maps.Point(15, 15)});
                    }
                    if (listClickMarker) {
                        listClickMarker.setMap(null);
                    }
                    clearAllInfoWindows(map);
                    let vm = this;
                    let fake = array.filter(function (item) {
                        return item.name == vm.dataset.name;
                    });
                    fake.forEach(function (ele) {
                        listClickInfowindow = new google.maps.InfoWindow ({
                            content: `
                            <div class="storeinfo"">
                                <a herf="javascript:void(0)">
                                    <div><img src="${ele.image}"></div>
                                    <div>
                                        <p>${ele.city_en} ${ele.name}</p>
                                        <p><span>${ele.postalcode} </span>${ele.address}</p>
                                        <p>
                                            <span>TEL：</span>${ele.tel}
                                        </p>
                                        <p>
                                            <span>FAX：</span>${ele.fax}
                                        </p>
                                        <div class="storedetail" data-src="https://${window.location.host}/wellcare/tw/store/${ele.id}" target="_blank">DETAIL 了解內容</div>
                                    </div>
                                </a>
                            </div>`,
                            position: { lat: Number(ele.lat), lng: Number(ele.lng) },
                        });
                        listClickMarker = new google.maps.Marker({
                            position: { lat: Number(vm.dataset.lat), lng: Number(vm.dataset.lng) },
                            map: map,
                            icon: {
                                url: '../../upload/F2E/store/googlemapmark-focus.png',
                                labelOrigin: new google.maps.Point(15, 15),
                            },
                            infowindow: listClickInfowindow,
                        });
                        // label: {
                        //     text: `${vm.dataset.index}`,
                        //     fontSize: '14px',
                        //     fontWeight: '700',
                        // },
                    });
                    map.setCenter({ lat: Number(vm.dataset.lat), lng: Number(vm.dataset.lng) });
                    listClickMarker.addListener('click', function() {
                        let vm = this;
                        console.log(this);
    
                        // 重複點擊關閉 infowindow
                        if(vm.infowindow.getMap() !== undefined && vm.infowindow.getMap() !== null){
                            vm.infowindow.close(map, vm);
                            vm.setIcon({url: '../../upload/F2E/store/googlemapmark.png', labelOrigin: new google.maps.Point(15, 15)});
                            // map.setZoom(14);
                            listClickMarker.setMap(null);
                            return; 
                        }
                        listClickMarker.infowindow.open(map, this);
                    });
                });
            });
        }
    };
};
